import { ZIGI_APP_RETURN_URL, ZigiPlainKey } from './zigiTypes';

const LOCAL_HOSTS = ['localhost', '127.0.0.1'];
const RETURN_URL_SCHEMES = ['https:', new URL(ZIGI_APP_RETURN_URL).protocol];
const SCHEME_PREFIX = /^[a-z][a-z0-9+.-]*(?=:\/\/)/i;

// Only full "scheme://target" values count: the URL parser alone also accepts "https:foo".
const parseUrl = (value: string): URL | undefined => {
  if (!/:\/\/\S/.test(value)) return undefined;
  try {
    return new URL(value);
  } catch {
    return undefined;
  }
};

export const isLocalHost = (hostname: string): boolean => LOCAL_HOSTS.includes(hostname);

export const isHttpsUrl = (value: string): boolean => parseUrl(value)?.protocol === 'https:';

// Plain http is only for a ZIGI mock, and only while the panel itself runs locally.
// The backend appends the gateway paths to it, so query, fragment and credentials have no place here.
export const isApiUrl = (value: string, allowLocalHttp: boolean): boolean => {
  const url = parseUrl(value);
  if (!url || url.search || url.hash || url.username || url.password) return false;
  return url.protocol === 'https:' || (allowLocalHttp && url.protocol === 'http:' && isLocalHost(url.hostname));
};

// ZIGI sends the customer back either to a web page or to the app through its own scheme.
export const isReturnUrl = (value: string): boolean => {
  const protocol = parseUrl(value)?.protocol;
  return !!protocol && RETURN_URL_SCHEMES.includes(protocol);
};

export const normalizePlain = (key: ZigiPlainKey, raw: string): string => {
  const value = raw.trim();
  if (key === 'apiUrl') return value.replace(/\/+$/, '');
  if (key === 'currency') return value.toUpperCase();
  // Android matches the app scheme case-sensitively, so it is stored in lower case.
  if (key === 'redirectUrl') return value.replace(SCHEME_PREFIX, scheme => scheme.toLowerCase());
  return value;
};
